/* =========================================================
   ZAETH ESSENTIAL SHOWCASE
   Product interaction + slider
   ========================================================= */

(function () {

  function initEssentialShowcase(section) {

    if (!section) return;

    const cards = Array.from(
      section.querySelectorAll('.zes-product-card')
    );

    const track = section.querySelector(
      '.zes-product-track'
    );

    const prevButton = section.querySelector(
      '.zes-prev'
    );

    const nextButton = section.querySelector(
      '.zes-next'
    );

    const currentNumber = section.querySelector(
      '.zes-counter-current'
    );

    const activeTitle = section.querySelector(
      '.zes-active-title'
    );

    const activeDetails = section.querySelector(
      '.zes-active-details'
    );

    const activePrice = section.querySelector(
      '.zes-active-price'
    );

    const viewPiece = section.querySelector(
      '.zes-view-piece'
    );

    if (!cards.length) return;


    /* =====================================================
       UPDATE ACTIVE PRODUCT
       ===================================================== */

    function activateProduct(index, shouldScroll) {

      if (cards.length === 0) return;

      index = Math.max(
        0,
        Math.min(index, cards.length - 1)
      );

      const card = cards[index];

      if (!card) return;


      /* Remove previous active state */

      cards.forEach(function (item) {

        item.classList.remove('is-active');

        item.setAttribute(
          'aria-selected',
          'false'
        );

      });


      /* Activate selected card */

      card.classList.add('is-active');

      card.setAttribute(
        'aria-selected',
        'true'
      );


      /* Product information */

      const name =
        card.dataset.productName || '';

      const details =
        card.dataset.productDetails || '';

      const price =
        card.dataset.productPrice || '';

      const link =
        card.dataset.productLink || '#';


      if (activeTitle) {
        activeTitle.textContent = name;
      }


      if (activeDetails) {
        activeDetails.textContent = details;
      }


      if (activePrice) {
        activePrice.textContent = price;
      }


      if (viewPiece) {

        viewPiece.href = link || '#';

      }


      /* Counter */

      if (currentNumber) {

        currentNumber.textContent =
          String(index + 1).padStart(2, '0');

      }


      /* Scroll card */

      if (
        shouldScroll &&
        track &&
        window.innerWidth <= 749
      ) {

        card.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start'
        });

      }

    }


    /* =====================================================
       CARD CLICK
       ===================================================== */

    cards.forEach(function (card, index) {

      card.addEventListener(
        'click',
        function () {

          activateProduct(
            index,
            true
          );

        }
      );

    });


    /* =====================================================
       PREVIOUS
       ===================================================== */

    if (prevButton) {

      prevButton.addEventListener(
        'click',
        function () {

          const activeIndex =
            cards.findIndex(function (card) {

              return card.classList.contains(
                'is-active'
              );

            });

          const nextIndex =
            activeIndex <= 0
              ? cards.length - 1
              : activeIndex - 1;

          activateProduct(
            nextIndex,
            true
          );

        }
      );

    }


    /* =====================================================
       NEXT
       ===================================================== */

    if (nextButton) {

      nextButton.addEventListener(
        'click',
        function () {

          const activeIndex =
            cards.findIndex(function (card) {

              return card.classList.contains(
                'is-active'
              );

            });

          const nextIndex =
            activeIndex >= cards.length - 1
              ? 0
              : activeIndex + 1;

          activateProduct(
            nextIndex,
            true
          );

        }
      );

    }


    /* =====================================================
       KEYBOARD NAVIGATION
       ===================================================== */

    section.addEventListener(
      'keydown',
      function (event) {

        if (event.key === 'ArrowRight') {

          const activeIndex =
            cards.findIndex(function (card) {

              return card.classList.contains(
                'is-active'
              );

            });

          activateProduct(
            activeIndex >= cards.length - 1
              ? 0
              : activeIndex + 1,
            true
          );

        }


        if (event.key === 'ArrowLeft') {

          const activeIndex =
            cards.findIndex(function (card) {

              return card.classList.contains(
                'is-active'
              );

            });

          activateProduct(
            activeIndex <= 0
              ? cards.length - 1
              : activeIndex - 1,
            true
          );

        }

      }
    );


    /* =====================================================
       MOBILE TRACK → ACTIVE CARD
       ===================================================== */

    if (track) {

      let scrollTimer;

      track.addEventListener(
        'scroll',
        function () {

          if (window.innerWidth > 749) {
            return;
          }

          clearTimeout(scrollTimer);

          scrollTimer = setTimeout(
            function () {

              const trackRect =
                track.getBoundingClientRect();

              const center =
                trackRect.left +
                trackRect.width / 2;


              let closestIndex = 0;
              let closestDistance = Infinity;


              cards.forEach(
                function (card, index) {

                  const rect =
                    card.getBoundingClientRect();

                  const cardCenter =
                    rect.left +
                    rect.width / 2;

                  const distance =
                    Math.abs(
                      center - cardCenter
                    );


                  if (
                    distance <
                    closestDistance
                  ) {

                    closestDistance =
                      distance;

                    closestIndex =
                      index;

                  }

                }
              );


              activateProduct(
                closestIndex,
                false
              );

            },
            100
          );

        },
        {
          passive: true
        }
      );

    }


    /* =====================================================
       INITIAL STATE
       ===================================================== */

    activateProduct(
      0,
      false
    );

  }


  /* =======================================================
     NORMAL PAGE LOAD
     ======================================================= */

  function boot() {

    document
      .querySelectorAll(
        '.zaeth-essential-showcase'
      )
      .forEach(function (section) {

        if (
          section.dataset.zesInitialized === 'true'
        ) {
          return;
        }

        section.dataset.zesInitialized = 'true';

        initEssentialShowcase(section);

      });

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      boot
    );

  } else {

    boot();

  }


  /* =======================================================
     SHOPIFY THEME EDITOR
     ======================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section =
        event.target.querySelector(
          '.zaeth-essential-showcase'
        );

      if (!section) return;

      section.dataset.zesInitialized = 'true';

      initEssentialShowcase(section);

    }
  );


  document.addEventListener(
    'shopify:section:unload',
    function (event) {

      const section =
        event.target.querySelector(
          '.zaeth-essential-showcase'
        );

      if (!section) return;

      section.dataset.zesInitialized = 'false';

    }
  );

})();